import React, { useState } from 'react'
import PropTypes from 'prop-types'

import {
  Typography,
  TextField,
  Paper,
  Grid,
} from '@material-ui/core'

import Alert from '@material-ui/lab/Alert';

import LoadingButton from './LoadingButton';

const UserForm = props => {
  const [username, setUsername] = useState('')
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [rpassword, setRPassword] = useState('')
  const [currentpassword, setCurrentPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChangeUserName = event => {
    if (event.key === "Enter") document.getElementById("password").focus();
    setUsername(event.target.value)
  }

  const handleChangePassword = event => {
    if (event.key === "Enter") handleSubmit(event);
    setPassword(event.target.value)
  }

  const handleChangeName = event => {
    setName(event.target.value)
  }

  const handleChangeRepeatedPassword = event => {
    setRPassword(event.target.value)
  }

  const handleChangeCurrentPassword = event => {
    setCurrentPassword(event.target.value)
  }

  const handleSubmit = e => {
    setLoading(true);
    props.handleSubmit(e, username, password, rpassword, currentpassword, name)
      .then(() => {
        setLoading(false);
      })
      .catch(error => {
        if (error.error) {
          setError(error.error)
        }
        setLoading(false);
        console.warn(error);
      })
  }

  function renderFields(handleSubmit) {
    return (
      <>
        {props.formType === 'register'
          ? renderInputField('Name', name, 'text', e => handleChangeName(e), 'name')
          : null}

        {props.formType !== 'reset_password' && props.formType !== 'change_password'
          ? renderInputField('Email', username, 'text', e => handleChangeUserName(e), 'username')
          : null}

        {props.formType === 'change_password'
          ? renderInputField('Current', currentpassword, 'password', e =>
              handleChangeCurrentPassword(e)
            )
          : null}

        {props.formType === 'register' ||
        props.formType === 'login' ||
        props.formType === 'reset_password' ||
        props.formType === 'change_password'
          ? renderInputField('Password', password, 'password', e => handleChangePassword(e))
          : null}
        {props.formType === 'reset_password' || props.formType === 'change_password'
          ? renderInputField('Repeat', rpassword, 'password', e => handleChangeRepeatedPassword(e))
          : null}
      </>
    )
  }
  
  function renderForm() {
    return (
      <Paper style={{padding: '24px 20px 20px', margin: '20px 0 30px'}}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant='h2' align="center" color='primary' style={{fontSize: '18px'}}><strong>{props.title}</strong></Typography>
          </Grid>
          {renderFields(handleSubmit)}
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              loading={loading}
              buttonStyle={{
                fontSize: '18px',
                height: '54px'
              }}
            >{props.formType}</LoadingButton>
          </Grid>
          { error && error.length > 0 && <Grid item xs={12}><Alert severity="error">{error}</Alert></Grid> }
        </Grid>
      </Paper>
    )
  }

  return (
    <form>
      {renderForm()}
    </form>
  )
}

const renderInputField = (name, value, type, fun, autoComplete) => {
  const lowerCaseName = name.toLowerCase()
  return (
    <Grid item xs={12}>
      <TextField
        required
        id={lowerCaseName}
        label={name}
        variant="outlined"
        value={value}
        type={type}
        onChange={fun}
        onKeyDown={fun}
        fullWidth
        autoComplete={autoComplete}
      />
    </Grid>
  )
}

UserForm.propTypes = {
  formType: PropTypes.string,
  handleSubmit: PropTypes.func,
  title: PropTypes.string
}

export default UserForm
